import script from "./Modular.vue?vue&type=script&lang=ts&setup=true"
export * from "./Modular.vue?vue&type=script&lang=ts&setup=true"

import "./Modular.vue?vue&type=style&index=0&id=351b6bfd&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351b6bfd"]])

export default __exports__